
import { Vue, Component, Prop } from "vue-property-decorator";

import TickIcon from "@/components/icons/TickIcon.vue";
import Cross from "@/components/icons/Cross.vue";
import Download from "@/components/icons/DownloadIcon.vue";
import UiButton from "@/components/button/ui-button.vue";
import CompleteIcon from "@/components/icons/Checkmark.vue";
import CheckMarkBlack from "@/components/icons/CheckMarkBlack.vue";
import DownloadIcon from "@/components/icons/DownloadBlack.vue";
import CalendarListHover from "@/components/icons/CalendarListHover.vue";
import CalendarList from "@/components/icons/CalendarList.vue";
import ListTable from "@/components/icons/ListTable.vue";
import ListTableHover from "@/components/icons/ListTableHover.vue";


@Component({
  components: {
    TickIcon,
    Cross,
    Download,
    CalendarListHover,
    CalendarList,
    UiButton,
    CompleteIcon,
    ListTable,
    ListTableHover,
    CheckMarkBlack,
    DownloadIcon,
  },
})
export default class Tabs extends Vue {
  @Prop({ type: Array, required: true }) tabs!: Array<{
    name: string;
  }>;
  @Prop({ type: Number, default: 0 }) activeTab!: number;
  @Prop({ default: () => [] }) readonly selectedRows: number[];
  @Prop({ default: () => [] }) readonly downloadAllTimesheets: number[];

  @Prop({ type: String, default: "", required: false })
  readonly tabClasses: string;

isHoveredCal: boolean = false;
isHoveredList: boolean = false;

  setActiveTab(index: number) {
    this.activeTab = index;
    this.$emit("update:activeTab", index);
  }
}
